import { Injector } from '@angular/core';

export const AppConstants = {
    urls: {
        app: {
            login: 'login',
        },
        api: {
            base: 'https://api.edap.com.pk/uat/api/',
            // base: 'http://95.216.234.30:6007/ut/api/',
            //base: 'https://ut.edu-man.com/ut/api/',
            application: "",
            reportNGUrl: "",
            reportUrl: "",

        },

    },
    settings: {
        version: '1.0.0.12',
        appCode: 'UT',
        instanceid: 1,
        instancecode: 'UT001',
        dateFormat: 'dd-MMM-yyyy',
        timeFormat: 'HH:mm',
        dateFormatforString: "DD-MMM-YYYY",
        timeFormatforString: "hh:mm:ss A",
        timeFormatTile: "hh:mm A",
        dateAndTime: "YYYY-MM-DDTHH:mm"
    },
    policy: {
        dateFormat: "",
        timeFormat: "",
        gridpagging: false,
        defaultcityid: 0,
        defaultctryid: 0,
        defaultstateid: 0
    },
    injector: <Injector>{}
};



// WEBPACK FOOTER //
// ./src/app/app.constant.ts